import Vue from "vue";
import store from "./store";
import router from "./router";
import Axios from "axios";
import BootstrapVue from "bootstrap-vue";
import VueMoment from "vue-moment";
import App from "./App.vue";
import UUID from "vue-uuid";
import i18n from "./i18n";
import VueGtag from "vue-gtag";
import {env} from "./env";

Vue.use(
  VueGtag,
  {
    config: { id: "G-5LF5J1XNDF" },
    defaultGroupName: "Tailie-Match-Plugin"
  },
  router
);
Vue.use(BootstrapVue);
Vue.use(VueMoment);
Vue.use(UUID);

Vue.config.productionTip = false;

const axiosConfig = {
  baseURL: `${env.VUE_APP_API_URL}/api/v2/`, // TODO: retrieve from docker env vars and .env file.
  headers: {
    Accept: "application/json",
    "X-DOMAIN": `${window.location.hostname}`
  }
};
Vue.$axios = Axios.create(axiosConfig);

Vue.$axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (
      error.response.status === 401 &&
      error.response.request.responseURL !==
        `${env.VUE_APP_API_URL}/api/v2/authenticate`
    ) {
      store.dispatch("auth/logout");
      router.push({ name: "login" });
    }
    return error;
  }
);

new Vue({
  store,
  router,
  i18n,
  render: h => h(App)
}).$mount("#tailie-plugin-match");
